import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-300395e4")

_pushScopeId("data-v-300395e4")
const _hoisted_1 = { class: "ai247-instance-rail" }
const _hoisted_2 = { class: "ai247-instance-rail__filters" }
const _hoisted_3 = { class: "ai247-instance-rail__heading" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h4", null, "Your AI 24/7 instances", -1)
const _hoisted_5 = { class: "ai247-instance-rail__heading-actions" }
const _hoisted_6 = { class: "ai247-instance-rail__count" }
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M9 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4M15 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4M10 8v8",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_8 = { class: "ai247-instance-rail__list" }
const _hoisted_9 = { class: "ai247-instance-row__avatar" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "ai247-instance-row__body" }
const _hoisted_12 = { class: "ai247-instance-row__title" }
const _hoisted_13 = { class: "ai247-instance-row__sub" }
const _hoisted_14 = { class: "ai247-instance-row__badge" }
const _hoisted_15 = { class: "ai247-instance-row__meta" }
const _hoisted_16 = {
  key: 0,
  class: "text-center py-6 fs-7 ai247-instance-rail__empty"
}
const _hoisted_17 = {
  key: 0,
  class: "ai247-instance-rail__footer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("aside", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterOptions, (option) => {
        return (_openBlock(), _createBlock("button", {
          key: option.value,
          type: "button",
          class: { 'is-active': _ctx.instanceFilter === option.value },
          onClick: ($event: any) => (_ctx.$emit('filter-change', option.value))
        }, _toDisplayString(option.label), 11, ["onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.totalCount), 1),
        _createVNode("button", {
          type: "button",
          class: "ai247-instance-rail__collapse",
          "aria-label": "Hide instances panel",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('collapse')))
        }, [
          _hoisted_7
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.visibleRows, (row) => {
        return (_openBlock(), _createBlock("button", {
          key: row.key,
          type: "button",
          class: ["ai247-instance-row", { 'is-active': row.key === _ctx.activeInstanceKey }],
          onClick: ($event: any) => (_ctx.$emit('select', row.key))
        }, [
          _createVNode("div", _hoisted_9, [
            (_ctx.avatarUrl)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.avatarUrl,
                  alt: ""
                }, null, 8, ["src"]))
              : (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(row.initials), 1))
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, _toDisplayString(row.title), 1),
            _createVNode("div", _hoisted_13, _toDisplayString(row.subLabel), 1)
          ]),
          _createVNode("span", _hoisted_14, _toDisplayString(row.statusLabel), 1),
          _createVNode("span", _hoisted_15, _toDisplayString(row.meta), 1)
        ], 10, ["onClick"]))
      }), 128)),
      (!_ctx.visibleRows.length)
        ? (_openBlock(), _createBlock("div", _hoisted_16, " No instances match this filter. "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.pendingActivationIds.length)
      ? (_openBlock(), _createBlock("div", _hoisted_17, [
          _createVNode("button", {
            type: "button",
            class: "btn btn-sm btn-light w-100",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('activate-another')))
          }, " Activate another AI 24/7 ")
        ]))
      : _createCommentVNode("", true)
  ]))
})